/* eslint-disable */

import React, { Component } from 'react';
import {
  Table,
  List,
  Button,
  Pagination,
  Container,
  Modal
} from 'semantic-ui-react';

import {
  insertPackage,
  getPackage
} from '../../services/PackageServiceManager';
import ModalDuplicatePackage from './ModalDuplicatePackage';
import './PackageList.css';
import PackageBuilderSearch from './PackageBuilderSearch';

class PackageList extends Component {
  state = {
    showConfirm: false,
    showModalDuplicate: false,
    packageToDuplicate: ''
  };

  renderAds = (id) => {
    const ads = this.props.packages.ads.filter((ad) => ad.package_id === id);

    return (
      <List>
        {ads.map((ad) => (
          <List.Item key={`${ad.name}-list-item`}>{ad.name}</List.Item>
        ))}
      </List>
    );
  };

  openDuplicateModal = (e, { data }) => {
    this.setState({
      showModalDuplicate: true,
      packageToDuplicate: data.package
    });
  };

  onCloseDuplicatePackageModal = () => {
    this.setState({ showModalDuplicate: false });
  };

  openDialog = (e, { data }) => {
    this.setState({ showConfirm: true, deleteRowId: data.id });
  };

  handleCancel = () => {
    this.setState({ showConfirm: false });
  };

  deletePackage = () => {
    this.props.deletePackage(this.state.deleteRowId);
    this.setState({ showConfirm: false });
  };

  launchPackage = (e, { data }) => {
    this.props.launchPackage(data.id);
  };

  editPackage = (e, { data }) => {
    this.props.editPackage(data.id);
  };

  onPageChange = (event, { activePage }) => {
    const { onPageChange } = this.props;

    if (onPageChange) onPageChange(activePage);
  };

  duplicatePackage = async (packageToDuplicate, packageName) => {
    const updatedPackage = await getPackage(packageToDuplicate.id);

    const packageData = {
      name: packageName,
      oem: packageToDuplicate.oem,
      user: packageToDuplicate.user || packageToDuplicate.created_by,
      campaigns: updatedPackage.packageData.campaigns,
      adsets: updatedPackage.packageData.adsets,
      ads: updatedPackage.packageData.ads
    };

    packageData.ads.map((ad) => {
      const adPrototype = this.props.adPrototypes.find(
        (item) => item.id === parseInt(ad.ad_prototype_id)
      );
      ad.ad = adPrototype;
    });

    const result = await insertPackage(packageData);
    this.onCloseDuplicatePackageModal();
    this.props.reloadPackages();
  };

  render() {
    const { pagination, newPackage, fetchPackagesWithName } = this.props;
    const { activePage, totalPages } = pagination;
    const { showModalDuplicate, packageToDuplicate } = this.state;

    if (this.props.packages) {
      return (
        <Container fluid>
          Search By Name:
          <PackageBuilderSearch fetchPackagesWithName={fetchPackagesWithName} />
          <div className="new-package-link">
            <Button onClick={newPackage}>NEW PACKAGE +</Button>
          </div>
          <Table sortable celled>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Package Name</Table.HeaderCell>
                <Table.HeaderCell>OEM</Table.HeaderCell>
                <Table.HeaderCell>Creator</Table.HeaderCell>
                <Table.HeaderCell>Ads</Table.HeaderCell>
                <Table.HeaderCell className="package-row-operations">
                  Operations
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {this.props.packages.packages.map((item) => (
                <Table.Row key={item.id}>
                  <Table.Cell>{item.name}</Table.Cell>
                  <Table.Cell>{item.oem}</Table.Cell>
                  <Table.Cell>{item.created_by}</Table.Cell>
                  <Table.Cell>{this.renderAds(item.id)}</Table.Cell>
                  <Table.Cell className="package-operations-buttons">
                    {this.state.showConfirm &&
                    item.id === this.state.deleteRowId ? (
                      <div className="package-div-confirm">
                        <p className="text-confirm">Are you sure?</p>
                        <Button
                          onClick={this.deletePackage}
                          size="mini"
                          color="grey"
                        >
                          Yes
                        </Button>
                        <Button
                          onClick={this.handleCancel}
                          size="mini"
                          color="red"
                        >
                          No
                        </Button>
                      </div>
                    ) : (
                      <div>
                        <Button
                          data={{ package: item }}
                          onClick={this.openDuplicateModal}
                          size="small"
                          color="blue"
                        >
                          Duplicate
                        </Button>
                        <Button
                          data={{ id: item.id }}
                          onClick={this.editPackage}
                          size="small"
                          color="blue"
                        >
                          Edit
                        </Button>
                        <Button
                          data={{ id: item.id }}
                          onClick={this.openDialog}
                          size="small"
                          color="blue"
                        >
                          Delete
                        </Button>
                        <Button
                          data={{ id: item.id }}
                          onClick={this.launchPackage}
                          size="small"
                          color="blue"
                        >
                          Launch
                        </Button>
                      </div>
                    )}
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
          <Container fluid textAlign="center">
            <Pagination
              onPageChange={this.onPageChange}
              activePage={activePage || 1}
              totalPages={totalPages}
              style={{ marginTop: '1em', marginBottom: '2em' }}
            />
          </Container>
          <Modal
            dimmer={'inverted'}
            open={showModalDuplicate}
            onClose={this.onCloseDuplicatePackageModal}
            size="small"
            className="modal-picker"
          >
            <Modal.Header>Duplicate Package</Modal.Header>
            <Modal.Content>
              <ModalDuplicatePackage
                onCloseDuplicatePackageModal={this.onCloseDuplicatePackageModal}
                duplicatePackage={this.duplicatePackage}
                packageToDuplicate={packageToDuplicate}
              />
            </Modal.Content>
          </Modal>
        </Container>
      );
    }
    return null;
  }
}

export default PackageList;



// WEBPACK FOOTER //
// ./src/screens/PackageBuilder/PackageList.js